import { render, staticRenderFns } from "./EndCustomer.vue?vue&type=template&id=5225cccd&"
import script from "./EndCustomer.vue?vue&type=script&lang=js&"
export * from "./EndCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EndCustomer.vue?vue&type=style&index=0&id=5225cccd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports